require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.symbol.observable.js
// module id = 542
// module chunks = 220